export class ConsoleTracker {
    constructor() {
        this.identify = (user) => console.log(JSON.stringify(user));
        this.trackEvent = (params) => {
            console.log(JSON.stringify(params));
        };
    }
}
